import { defaultConfig } from '@tamagui/config/v6'
import { createTamagui } from 'tamagui'
import { themes } from './themes'
import { blue, extraRadius, neutral, signal } from './tokens'

// Tamagui 3 config: the stock v6 config (fonts, animations, media queries, space/size/radius
// scales) plus the ensemble colors, themes and z-index layers from docs/STYLE.md.
// Light only - the themes object has no dark entry, so nothing can switch away from light.
export const config = createTamagui({
  ...defaultConfig,
  themes,
  tokens: {
    ...defaultConfig.tokens,
    color: { ...defaultConfig.tokens.color, ...blue, ...neutral, ...signal },
    radius: { ...defaultConfig.tokens.radius, ...extraRadius },
  },
  settings: {
    ...defaultConfig.settings,
    // no prefers-color-scheme handling: there is only one theme
    shouldAddPrefersColorThemes: false,
    themeClassNameOnRoot: true,
  },
})

export type Conf = typeof config

declare module 'tamagui' {
  interface TamaguiCustomConfig extends Conf {}
}
